import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=756fc4e9&"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js&"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports